import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuItem,
} from "@/components/blocks/evo-sidebar";
import type { MenuItem } from "../types";

interface FavoritesSectionProps {
  favoriteItems: MenuItem[];
  renderMenuItem: (item: MenuItem, uniqueId: string, isFavoriteItem?: boolean) => React.ReactNode;
}

/**
 * Favorites Section Component
 * Displays favorited menu items at the top of the sidebar
 */
export function FavoritesSection({ favoriteItems, renderMenuItem }: FavoritesSectionProps) {
  if (favoriteItems.length === 0) {
    return null;
  }

  return (
    <>
      <SidebarGroup className="group-data-[state=collapsed]:items-center">
        <SidebarGroupLabel className="group-data-[state=collapsed]:hidden">
          Favorites
        </SidebarGroupLabel>
        <SidebarGroupContent className="group-data-[state=collapsed]:w-8">
          <SidebarMenu className="gap-0.5 group-data-[state=collapsed]:w-full [&_span]:transition-all [&_span]:duration-200 [&_span]:ease-out [&_span]:opacity-100 [&_span]:translate-x-0 group-data-[state=collapsed]:[&_span]:opacity-0 group-data-[state=collapsed]:[&_span]:-translate-x-2 group-data-[state=collapsed]:[&_span]:pointer-events-none">
            {favoriteItems.map((item) => (
              <SidebarMenuItem key={`fav-${item.id}`}>
                {renderMenuItem(item, `fav-${item.id}`, true)}
              </SidebarMenuItem>
            ))}
          </SidebarMenu>
        </SidebarGroupContent>
      </SidebarGroup>
      <div className="border-t border-neutral-200 my-2 mx-2 group-data-[state=collapsed]:mx-auto group-data-[state=collapsed]:w-8"></div>
    </>
  );
}
